import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Empresa } from '../../entities/empresa';
import { Api } from '../../providers/api/api';

import * as _ from 'lodash';
import * as moment from "moment";

moment.locale('pt-BR');

interface PeriodoFaturamentoMultiloja {
    Id: string;
    DataEmissao: number;
    QuantidadePeca: number;
    ValorLiquido: number;
    Empresa: Empresa;
}

@Component({
    selector: 'periodo-fat-multilojas',
    templateUrl: 'periodo-fat-multilojas.html'
})
export class PeriodoFaturamentoMultilojasComponent implements OnInit, OnDestroy {
    public hoje: string = new Date().toISOString();
    public dataInicial: string = new Date("2010-03-24").toISOString();
    public dataFinal: string = new Date().toISOString();

    @Input('analytic') analytic: boolean = false;

    public faturamentoMultilojaDilady: any;
    public faturamentoMultilojaLoveSecret: any;
    public faturamentoMultilojaBanhoDeMar: any;
    public faturamentoMultilojaGrupo: any;

    public carregandoDados: boolean = true;

    private _myInterval: number;

    constructor(
        private _api: Api
    ) { }

    public ngOnInit(): void {
        this.carregandoDados = true;
        this._separarLojas();

        if (this._myInterval)
            clearInterval(this._myInterval);

        this._myInterval = setInterval(() => {
            this._separarLojas();
        }, 30000);
    }

    public ngOnDestroy(): void {
        clearInterval(this._myInterval);
    }

    private _separarLojas(): void {
        this._obterPeriodoFaturamentoMultiloja().then(periodosBruto => {
            let periodos = periodosBruto.filter(a => moment(a.DataEmissao).isBetween(this.dataInicial, this.dataFinal));

            this.faturamentoMultilojaGrupo = {
                QuantidadePeca: _.sum(periodos.map(a => a.QuantidadePeca)),
                ValorLiquido: _.sum(periodos.map(a => a.ValorLiquido))
            }
            this.faturamentoMultilojaGrupo.PrecoMedio = (this.faturamentoMultilojaGrupo.ValorLiquido / this.faturamentoMultilojaGrupo.QuantidadePeca);

            let faturamentoMultilojaDilady = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 1));
            if (faturamentoMultilojaDilady.length > 0) {
                this.faturamentoMultilojaDilady = {
                    QuantidadePeca: _.sum(faturamentoMultilojaDilady.map(a => a.QuantidadePeca)),
                    ValorLiquido: _.sum(faturamentoMultilojaDilady.map(a => a.ValorLiquido)),
                    Empresa: faturamentoMultilojaDilady[0].Empresa
                }
                this.faturamentoMultilojaDilady.PrecoMedio = (this.faturamentoMultilojaDilady.ValorLiquido / this.faturamentoMultilojaDilady.QuantidadePeca);
            } else {
                this.faturamentoMultilojaDilady = {
                    QuantidadePeca: 0,
                    ValorLiquido: 0,
                    PrecoMedio: 0,
                    Empresa: { Id: 1, Descricao: 'Dilady Lingerie' }
                }
            }

            let faturamentoMultilojaLoveSecret = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 2));
            if (faturamentoMultilojaLoveSecret.length > 0) {
                this.faturamentoMultilojaLoveSecret = {
                    QuantidadePeca: _.sum(faturamentoMultilojaLoveSecret.map(a => a.QuantidadePeca)),
                    ValorLiquido: _.sum(faturamentoMultilojaLoveSecret.map(a => a.ValorLiquido)),
                    Empresa: faturamentoMultilojaLoveSecret[0].Empresa
                }
                this.faturamentoMultilojaLoveSecret.PrecoMedio = (this.faturamentoMultilojaLoveSecret.ValorLiquido / this.faturamentoMultilojaLoveSecret.QuantidadePeca);
            } else {
                this.faturamentoMultilojaLoveSecret = {
                    QuantidadePeca: 0,
                    ValorLiquido: 0,
                    PrecoMedio: 0,
                    Empresa: { Id: 2, Descricao: 'Love Secret Lingerie' }
                }
            }

            let faturamentoMultilojaBanhoDeMar = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 3));
            if (faturamentoMultilojaBanhoDeMar.length > 0) {
                this.faturamentoMultilojaBanhoDeMar = {
                    QuantidadePeca: _.sum(faturamentoMultilojaBanhoDeMar.map(a => a.QuantidadePeca)),
                    ValorLiquido: _.sum(faturamentoMultilojaBanhoDeMar.map(a => a.ValorLiquido)),
                    Empresa: faturamentoMultilojaBanhoDeMar[0].Empresa
                }
                this.faturamentoMultilojaBanhoDeMar.PrecoMedio = (this.faturamentoMultilojaBanhoDeMar.ValorLiquido / this.faturamentoMultilojaBanhoDeMar.QuantidadePeca);
            } else {
                this.faturamentoMultilojaBanhoDeMar = {
                    QuantidadePeca: 0,
                    ValorLiquido: 0,
                    PrecoMedio: 0,
                    Empresa: { Id: 3, Descricao: 'Banho de Mar Acquashape' }
                }
            }

            setTimeout(() => {
                this.carregandoDados = false;
            }, 1000);
        }).catch(error => {
            console.error(error);
        });
    }

    private _obterPeriodoFaturamentoMultiloja(): Promise<PeriodoFaturamentoMultiloja[]> {
        return new Promise((resolve, reject) => {
            this._api.get('PeriodoFaturamentoMultiloja').subscribe(response => resolve(JSON.parse(response._body)), reject);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/periodo-fat-multilojas/periodo-fat-multilojas.ts